import * as constants from "./constants";
import postureConfig from "./postureConfig";
import * as utils from "./utils";

export const SecurityPosture = {
  constants,
  utils,
  postureConfig,
};
